import { PermisoDto } from "../permisos/permisoDto.model";

export class RolDto {

    public id : number=0;
    public descripcion : string="";
    public permisos : PermisoDto[] = [];

}
